import { useQuery } from '@tanstack/react-query';
import { fetchUiConfig } from '../../../../config/shared/library/client/fetchUiConfig';

export const useGetUiConfig = (uiConfigName: string | undefined) => {
  const isEnabled = Boolean(uiConfigName) && typeof uiConfigName === 'string';
  const {
    data: uiConfig,
    isError,
    isLoading,
    // Typecasting as string as the hook will not be enabled until uiConfigName is a string.
  } = useQuery(['ui-config'], () => fetchUiConfig(uiConfigName as string), { enabled: isEnabled });

  return {
    isError,
    isLoading,
    uiConfig,
  };
};
